import {ofType} from 'redux-observable';
import {Observable} from 'rxjs';
import {List} from 'immutable';
import i18next from 'i18next';
import {mergeMap, flatMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as FileActions from 'web-app/react/components/file-upload/actions';
import FileRecord from 'web-app/react/components/file-upload/file-record';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import {clearFiles} from 'web-app/react/components/file-upload/actions';

import * as Api from './api';
import * as Constants from './constants';
import * as Actions from './actions';

const imageToFileRecord = (image: any) => {
    if (!image) {
        return undefined;
    }

    return new FileRecord({
        name: '',
        type: 'image',
        id: image.imageId,
        uploadProgress: undefined,
        previewUrl: image.url,
        thumbnailUrl: image.url,
        videoDuration: undefined,
    });
};

const fetchInvoiceSettings = action$ =>
    action$.pipe(
        ofType(Actions.fetchInvoiceSettings.type),
        mergeMap(({payload}: ReturnType<typeof Actions.fetchInvoiceSettings.action>) => {
            const fetchRoutine = Api.fetchInvoiceSettings(payload.institutionId).pipe(
                flatMap(invoiceSettings => [
                    Actions.fetchInvoiceSettingsSuccess.action(invoiceSettings),
                    FileActions.loadFiles(
                        Constants.invoiceSettingsFormName,
                        invoiceSettings.logo && List([imageToFileRecord(invoiceSettings.logo)]),
                    ),
                ]),
            );

            return Observable.concat(Observable.of(clearFiles(Constants.invoiceSettingsFormName)), fetchRoutine).catch(
                e => Observable.of(Actions.fetchInvoiceSettingsFailed.action(e)),
            );
        }),
    );

const updateInvoiceSettings = action$ =>
    action$.pipe(
        ofType(Actions.updateInvoiceSettings.type),
        mergeMap(({payload}: ReturnType<typeof Actions.updateInvoiceSettings.action>) =>
            Api.updateInvoiceSettings(payload.institutionId, payload.settings).pipe(
                flatMap(() => [
                    Actions.updateInvoiceSettingsSuccess.action(),
                    GlobalEventActions.updateSuccess.action(i18next.t('plans.settings.invoice.updatedConfirmation')),
                ]),
                catchError(e => Observable.of(Actions.updateInvoiceSettingsFailed.action(e))),
            ),
        ),
    );

export default combineEpics(fetchInvoiceSettings, updateInvoiceSettings);
